<template>
    <!-- 記事内に表示するアプリ起動ボタン・インストールボタン -->
    <div v-show="isMobile">
        <p class="text-left">
            <a v-on:click="launchApp()" 
            class="btn btn-info btn-lg"
             role="button">
                <LabelFunMessage fcontId="0" msgkey="30" />&nbsp;&raquo;
            </a>
        </p>

        <p>
            <span class="how_point">
                <span class="glyphicon glyphicon-info-sign"></span>
                <LabelFunMessage fcontId="0" msgkey="31" />
            </span>
        </p>
        <!-- iOS9以降でセキュリティが強化された関係で、
        アプリがインストールされていない場合数秒後に遷移することが
        できなくなってしまったため、インストールボタンを表示 -->
        <p v-show="isIOS" class="text-left">
            <a href="https://geo.itunes.apple.com/us/app/epson-creative-print/id685791389?pt=280580&ct=gallery&mt=8"
                class="btn btn-default btn-lg" 
                role="button" 
                target="_blank" 
                v-on:click="trackGaEvent('install_creative_iOS')">
                <LabelFunMessage fcontId="0" msgkey="32" />&nbsp;&raquo;
            </a></p>
    </div>
</template>

<script>
    import {
        APPLINK
    } from "@/common/creativeprintlink";
    import {
        mapState
    } from "vuex";
    import LabelFunMessage from './LabelFunMessage';
    export default {
        name: "CreativePrintInText",
        components: {
            LabelFunMessage
        },
        computed: {
            ...mapState(["os"]),
            fcontid: function () {
                return this.$route.path.match(/\/\d+/).shift().slice(1)
            },
            isIOS: function () {
                return this.os == 'ios'
            },
            isMobile: function () {
                return this.os == 'ios' || this.os == 'ard'
            }
        },
        methods: {
            trackGaEvent: function (action) {
                //GA4
                if (action == "install_creative_iOS") {
                    this.trackGa4AppDownloadEvent()
                }else {
                    this.trackGa4GoAppEvent()
                }
            },
            trackGa4AppDownloadEvent: function() {
                this.$gtag.event("app_download", {
                    "app_name": "Creative Print",
                    "location_id": "old",
                    "article_no": this.fcontid,
                    "site_id": "gallery"
                })
            },
            trackGa4GoAppEvent: function() {
                const applink = APPLINK[this.fcontid];
                this.$gtag.event("go_app", {
                    "app_name": "Creative Print",
                    "article_no": this.fcontid,
                    "print_type": "old",
                    "design_id": applink.design_id,
                    "site_id": "gallery"
                })
            },        
            launchApp: function () {
                this.trackGaEvent('launchApp_creative')
                let pinfOption = `fcont_${this.fcontid}`;
                var applink = APPLINK[this.fcontid];

                const applicationtype = applink.apptype;
                switch (applicationtype) {
                    case "launch": {
                        this.launchCreativePrint(this.os, pinfOption);
                        break;
                    }
                    case "print": {
                        this.printCreativePrint(this.os, applink, pinfOption);
                        break;
                    }
                }
            },
            launchCreativePrint: function (clientDevice, pinfOption) {
                //Creative Print  アプリを起動
                switch (clientDevice) {
                    case "ios": {
                        const IOS_URLSCHEME = "com.epson.mobilephone.creative";
                        const BASE_APPOPTION = "launch";
                        const query = [{
                            key: "source_app",
                            value: `Epson.sn_${pinfOption}`
                        }];
                        this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
                        break;
                    }
                    case "ard": {
                        const ANDROID_URLSCHEME = "com.epson.mobilephone.creative";
                        const ANDROID_PACKAGE = "com.epson.mobilephone.creative";
                        const query = [{
                            key: "S.source_app",
                            value: `Epson.sn_${pinfOption}`
                        }];
                        this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
                        break;
                    }
                }
            },
            printCreativePrint: function (clientDevice, applink, pinfOption) {
                switch (clientDevice) {
                    case "ios": {
                        const IOS_URLSCHEME = "com.epson.mobilephone.creative.designpaper.v1";
                        const BASE_APPOPTION = "print";
                        const query = [{
                                key: "design_id",
                                value: applink.design_id
                            },
                            {
                                key: "angle",
                                value: applink.angle
                            },
                            {
                                key: "media_type",
                                value: applink.media_type
                            },
                            {
                                key: "media_size",
                                value: applink.media_size
                            },
                            {
                                key: "source_app",
                                value: `Epson.sn_${pinfOption}`
                            }
                        ];
                        this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
                        break;
                    }
                    case "ard": {
                        const ANDROID_URLSCHEME =
                            "com.epson.mobilephone.creative.designpaper.v1";
                        const ANDROID_PACKAGE = "com.epson.mobilephone.creative"; //S.source_app=Epson.sn.test1";

                        const query = [{
                                key: "S.design_id",
                                value: applink.design_id
                            },
                            {
                                key: "i.angle",
                                value: applink.angle
                            },
                            {
                                key: "i.media_type",
                                value: applink.media_type
                            },
                            {
                                key: "i.media_size",
                                value: applink.media_size
                            },
                            {
                                key: "S.source_app",
                                value: `Epson.sn_${pinfOption}`
                            }
                        ];
                        this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
                    }
                }
            },
            openIOSURL: function (scheme, appoption, query) {
                const IOSquery = query.map(q => `${q.key}=${q.value}`).join("&");
                const IOS_OPENURL = `${scheme}:///${appoption}?${IOSquery}`;
                window.location = IOS_OPENURL;
                this.$log.debug('url', IOS_OPENURL);
            },
            openAndroidURL: function (scheme, andpackage, query) {
                const Androidquery = query.map(q => `${q.key}=${q.value}`).join(";");
                const ANDROID_OPENURL =
                    `intent://#Intent;scheme=${scheme};package=${andpackage};${Androidquery};end;`;
                window.location = ANDROID_OPENURL;
                this.$log.debug('url', ANDROID_OPENURL);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>